import Vue from 'vue'
import Vuex from 'vuex'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
dayjs.locale('ja')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    eventStartDate: dayjs('2020-07-04T12:00'),
    eventEndDate: dayjs('2020-07-19T23:59'),
    pamphletOrderStartDate: dayjs('2020-06-25T13:00'),
    pamphletOrderEndDate: dayjs('2020-07-19T23:59'),
    talkEventStartDate: dayjs('2020-07-19T14:00'),
    talkEventEndDate: dayjs('2020-07-19T17:00'),
    sessionalStatus: 'pre', //会期前=pre, 会期中=mid, 会期後=post
    pamphletOrderStatus: 'pre', //会期前=pre, 会期中=mid, 会期後=post
    isWorksModalActive: false,
  },
  getters: {
    getStartDate (state) {
      return state.eventStartDate
    },
    getEndDate (state) {
      return state.eventEndDate
    },
    getPamphletOrderStartDate (state) {
      return state.pamphletOrderStartDate
    },
    getPamphletOrderEndDate (state) {
      return state.pamphletOrderEndDate
    },
    getTalkEventStartDate (state) {
      return state.talkEventStartDate
    },
    getTalkEventEndDate (state) {
      return state.talkEventEndDate
    },
    getSessionalStatus (state) {
      return state.sessionalStatus
    },
    getPamphletOrderStatus (state) {
      return state.pamphletOrderStatus
    },
    getIsWorksModalActive (state) {
      return state.isWorksModalActive
    },
  },
  mutations: {
    updateSessionalStatus (state, sessionalStatus) {
      state.sessionalStatus = sessionalStatus
    },
    updateIsWorksModalActive (state, isWorksModalActive) {
      state.isWorksModalActive = isWorksModalActive
    },
    updatePamphletOrderStatus (state, pamphletOrderStatus) {
      state.pamphletOrderStatus = pamphletOrderStatus
    },
  },
  actions: {
    updateSessionalStatus (context, sessionalStatus) {
      context.commit('updateSessionalStatus', sessionalStatus)
    },
    updateIsWorksModalActive (context, isWorksModalActive) {
      context.commit('updateIsWorksModalActive', isWorksModalActive)
    },
    updatePamphletOrderStatus (context, pamphletOrderStatus) {
      context.commit('updatePamphletOrderStatus', pamphletOrderStatus)
    },
  },
  modules: {
  }
})
